// 15-Fragen-Katalog des KI-Kompass.
// Jede Frage hat dialog-orientierte Antwortoptionen mit numerischem Score-Wert.

export const QUESTIONS = [
  {
    id: "q1",
    intro: "Stellen wir uns einen ganz normalen Mittwochmorgen vor.",
    text: "Wenn Sie morgen früh um 08:00 Uhr Ihren Posteingang öffnen – wie viele Anfragen warten dort, die Sie eigentlich schon gestern und vorgestern so ähnlich beantwortet haben?",
    options: [
      { value: 0, label: "Kaum welche", hint: "0 – 5 Anfragen" },
      { value: 1, label: "Einige wiederkehrende", hint: "5 – 15 Anfragen" },
      { value: 2, label: "Spürbar viele", hint: "15 – 30 Anfragen" },
      { value: 3, label: "Sehr viele, fast jeden Tag", hint: "30+ Anfragen" },
    ],
  },
  {
    id: "q2",
    text: "Wie viele Stunden pro Woche verbringen Sie oder Ihr Team damit, Informationen in verschiedenen Ordnern oder bei Kollegen zusammenzusuchen?",
    options: [
      { value: 0, label: "Weniger als 2 Stunden" },
      { value: 1, label: "2 – 5 Stunden" },
      { value: 2, label: "5 – 10 Stunden" },
      { value: 3, label: "Mehr als 10 Stunden" },
    ],
  },
  {
    id: "q3",
    text: "Gibt es eine Aufgabe, bei der Sie sich manchmal wie eine „kaputte Schallplatte\" fühlen, weil Sie immer wieder das Gleiche erklären müssen?",
    options: [
      { value: 0, label: "Nein, eigentlich nie" },
      { value: 1, label: "Selten" },
      { value: 2, label: "Manchmal" },
      { value: 3, label: "Ja, sehr häufig" },
    ],
  },
  {
    id: "q4",
    text: "Geht es dabei hauptsächlich um Schreiben, Suchen oder Terminorganisation?",
    options: [
      { value: 1, label: "Hauptsächlich Schreiben", hint: "E-Mails, Briefe, Protokolle" },
      { value: 2, label: "Hauptsächlich Suchen", hint: "Informationen, Akten, Wissen" },
      { value: 2, label: "Hauptsächlich Terminorganisation", hint: "Abstimmungen, Koordination" },
      { value: 3, label: "Von allem etwas" },
    ],
  },
  {
    id: "q5",
    text: "Liegt das Wissen dazu in Dokumenten oder hauptsächlich in den Köpfen erfahrener Mitarbeiter?",
    options: [
      { value: 0, label: "Hauptsächlich in Dokumenten" },
      { value: 1, label: "Gemischt – etwa zur Hälfte" },
      { value: 2, label: "Vor allem in den Köpfen einzelner Personen" },
    ],
  },
  {
    id: "q6",
    text: "Was würde passieren, wenn Ihr erfahrenster Mitarbeiter morgen für drei Monate ausfällt?",
    options: [
      { value: 0, label: "Wenig – wir kommen gut zurecht" },
      { value: 1, label: "Teilweise Probleme – einige Abläufe stocken" },
      { value: 2, label: "Großes Problem – vieles wäre nicht ersetzbar" },
    ],
  },
  {
    id: "q7",
    text: "Nutzen Sie bereits digitale Systeme, die Daten speichern, aber Ihren Alltag nicht spürbar vereinfachen?",
    options: [
      { value: 0, label: "Nein, unsere Systeme entlasten uns" },
      { value: 1, label: "Teilweise – nur in einigen Bereichen" },
      { value: 2, label: "Ja, mehrere Systeme – Aufwand statt Entlastung" },
    ],
  },
  {
    id: "q8",
    text: "Was würden Sie tun, wenn Sie ab morgen jede Woche fünf Stunden zusätzliche Zeit hätten?",
    options: [
      { value: 2, label: "Strategische Aufgaben angehen" },
      { value: 2, label: "Mitarbeiterführung und Entwicklung" },
      { value: 1, label: "Weniger Überstunden, mehr Erholung" },
      { value: 2, label: "Bürger- oder Kundenkontakt vertiefen" },
    ],
  },
  {
    id: "q9",
    text: "Was bereitet Ihnen mehr Sorgen: Fehler durch KI oder der Verlust sensibler Daten?",
    options: [
      { value: 1, label: "Vor allem Fehler durch KI" },
      { value: 2, label: "Vor allem Verlust sensibler Daten" },
      { value: 2, label: "Beides etwa gleich stark" },
      { value: 0, label: "Keines von beidem ist mir wichtig" },
    ],
  },
  {
    id: "q10",
    text: "Wäre es für Sie wichtig, dass eine KI vollständig in Ihrer eigenen Umgebung betrieben werden kann?",
    options: [
      { value: 3, label: "Sehr wichtig – nur eigene Umgebung" },
      { value: 2, label: "Eher wichtig" },
      { value: 1, label: "Eher unwichtig" },
      { value: 0, label: "Spielt für uns keine Rolle" },
    ],
  },
  {
    id: "q11",
    text: "Ist es für Sie wichtig, dass der Mensch immer die finale Entscheidung trifft?",
    options: [
      { value: 3, label: "Sehr wichtig – Mensch entscheidet immer" },
      { value: 2, label: "Eher wichtig" },
      { value: 1, label: "Eher unwichtig" },
      { value: 0, label: "Eine KI darf auch eigenständig entscheiden" },
    ],
  },
  {
    id: "q12",
    text: "Wären Sie bereit, eine kleine Lösung für genau eine Aufgabe 14 Tage lang zu testen?",
    options: [
      { value: 2, label: "Ja, gerne" },
      { value: 1, label: "Vielleicht – kommt darauf an" },
      { value: 0, label: "Eher nein" },
    ],
  },
  {
    id: "q13",
    text: "Was hat Sie bisher am meisten gebremst: Zeit, Budget oder Komplexität?",
    options: [
      { value: 3, label: "Zeit – uns fehlen die Köpfe für solche Themen" },
      { value: 2, label: "Budget – die Mittel sind sehr begrenzt" },
      { value: 2, label: "Komplexität – wir wissen nicht, wo wir anfangen sollen" },
      { value: 3, label: "Eine Mischung aus mehreren Punkten" },
    ],
  },
  {
    id: "q14",
    text: "Werden Mitarbeiter eher durch Konzepte oder durch praktische Entlastung überzeugt?",
    options: [
      { value: 0, label: "Konzepte – wir mögen klare Strukturen" },
      { value: 2, label: "Praktische Entlastung – sichtbare Erleichterung" },
      { value: 1, label: "Beides ist nötig" },
    ],
  },
  {
    id: "q15",
    text: "Wollen wir den ersten Schritt jetzt gemeinsam definieren?",
    options: [
      { value: 2, label: "Ja, jetzt direkt" },
      { value: 1, label: "Bald – in den nächsten Wochen" },
      { value: 0, label: "Erst möchten wir uns weiter informieren" },
    ],
  },
];

export const SCORE_META = [
  {
    key: "zeitfresser",
    label: "Zeitfresser-Score",
    short: "Zeitfresser",
    description: "Wie stark Routine- und Wiederholungsaufgaben Ihre Woche dominieren.",
  },
  {
    key: "wiederholung",
    label: "Wiederholungs-Score",
    short: "Wiederholung",
    description: "Wie häufig Sie und Ihr Team das Gleiche erneut tun oder erklären.",
  },
  {
    key: "wissensverlust",
    label: "Wissensverlust-Score",
    short: "Wissensverlust",
    description: "Wie stark Wissen an einzelne Köpfe gebunden ist – statt an Strukturen.",
  },
  {
    key: "entlastung",
    label: "Entlastungs-Score",
    short: "Entlastung",
    description: "Wie groß das spürbare Entlastungspotenzial in Ihrem Alltag ist.",
  },
  {
    key: "ki_bereitschaft",
    label: "Handlungsfähigkeit",
    short: "Handlungsfähigkeit",
    description: "Wie tragfähig die organisatorische Basis für einen ersten Pilot ist.",
  },
];

export const BRANCHEN = [
  "Kommune / Verwaltung",
  "Stadtwerk / Versorger",
  "Kläranlage / Wasserwirtschaft",
  "Handwerksbetrieb",
  "Mittelständisches Unternehmen",
  "Sonstige",
];
